import { render, staticRenderFns } from "./EditorialPushItem.vue?vue&type=template&id=b02ad0da&scoped=true&"
import script from "./EditorialPushItem.vue?vue&type=script&lang=ts&"
export * from "./EditorialPushItem.vue?vue&type=script&lang=ts&"
import style0 from "./EditorialPushItem.vue?vue&type=style&index=0&id=b02ad0da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02ad0da",
  null
  
)

export default component.exports